<template>
    <div id="newResidual">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart" style="width: 17%;">
            <p class="headerT">残值信息</p>
            <el-form ref="returnForm" :model="returnForm" label-width="80px" :label-position="labelPosition">
                <el-form-item label="操作类型:">
                    <el-input :disabled="true" v-model="returnForm.operatorName"></el-input>
                </el-form-item>
                <el-form-item label="操作人:">
                    <el-input :disabled="true" v-model="returnForm.createUser" ></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 81%;">
            <el-button type="success" size="medium" @click="dislogSerial = true" style="margin-bottom: 15px;">扫码输入</el-button>
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    type="index"
                    width="50"
                    label="序号">
                </el-table-column>
                <el-table-column
                    align="center"
                    type="index"
                    width="150"
                    label="序列号">
                    <template slot-scope="scope">
                        {{scope.row.codeTotal[0]}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="forecastValue"
                    width="200"
                    label="残值价格">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    width="50">
                    <template slot-scope="scope">
                        <el-button @click.stop="deleteRow(scope.$index, returnData)" type="text" size="small">移除</el-button>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click.stop="showSerialNumber(scope.$index, scope.row)" type="text" size="small">查看序列号</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="totalDiv">
                <small>数量：</small>
                <strong >{{totalCount}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
                <span>
                    <small >总计：</small>
                    <strong >{{totalMoney}}</strong> 元
                </span>
            </div>
            <el-dialog title="添加序列号" :visible.sync="dislogSerial" :close-on-click-modal="false" width="1200px"  @close="cancelSerial()">
                <el-row>
                    <el-col>
                        <el-form v-if="dislogSerial" ref="materialParams" :model="materialParams">
                            <el-form-item>
                                <el-input  clearable style="width:30%;" @input="queryBySerialNumberData" v-model.trim="materialParams.number" :autofocus="dislogSerial" placeholder="请输入或扫描序列号"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <span class="scanTitle">扫描记录</span>
                        <el-row style="height: 540px;border:1px solid #EBEEF5">
                            <el-table
                                :data="codeList"
                                :border="false"
                                height="465"
                                :header-cell-style="{'text-align':'center'}"
                                style="width: 100%;">
                                <el-table-column
                                    align="center"
                                    type="index"
                                    width="50"
                                    label="序号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialCode"
                                    label="物料编号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="modelName"
                                    label="型号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="物料属性">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.state == 1">未使用</span>
                                        <span v-else-if="scope.row.state == -1">已使用</span>
                                        <span v-else>异常</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    width="200"
                                    prop="materialName"
                                    label="物料名称">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    width="100"
                                    label="预估残值">
                                    <template slot-scope="scope">
                                        <el-input class="priceContent" size="small" v-model="scope.row.forecastValue"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="code"
                                    width="150"
                                    label="序列号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="操作"
                                    width="50">
                                    <template slot-scope="scope">
                                        <el-button @click.stop="deleteCode(scope.$index, codeList)" type="text" size="small">移除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button type="success" size="small" class="fr" style="margin: 20px;" @click="scanCompelte">扫描完毕</el-button>
                        </el-row>
                    </el-col>
                    <el-col :span="12">
                        <span class="scanTitle">扫描汇总</span>
                        <el-row style="height: 540px;border:1px solid #EBEEF5">
                            <el-table
                                :data="scanTotalList"
                                height="540"
                                :border="false"
                                :header-cell-style="{'text-align':'center'}"
                                style="width: 100%;">
                                <el-table-column
                                    align="center"
                                    type="index"
                                    width="50"
                                    label="序号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialCode"
                                    label="物料编号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="modelName"
                                    label="型号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="物料属性">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.state == 1">未使用</span>
                                        <span v-else-if="scope.row.state == -1">已使用</span>
                                        <span v-else>异常</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialName"
                                    width="200"
                                    label="物料名称">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="forecastValue"
                                    label="预估残值">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="count"
                                    label="数量">
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button type="success" size="small" @click="addSerialComformBtn()">添加</el-button>
                    <el-button size="small" @click="cancelSerial()">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 查看序列号弹出框 -->
            <el-dialog  class="dialog-content" :visible.sync="dialogTableVisible">
                <el-row
                    class="dialog-code-content"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading">
                    <el-col v-for="(item,index) in checkCodeList" v-if="item != ''" :key="index" :span="6">
                        <p>{{item}}</p>
                    </el-col>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogTableVisible = false">关闭</el-button>
                </div>
            </el-dialog>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave()">提交</el-button>
            <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
                {{pageStatus}}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
                    <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        queryBySerialNumber,
        wasteAdd
    } from "../../../api/api";
    export default {
        name: 'newResidual',
        components: {},
        data () {
            return {
                totalCount:0,           //物料总数量
                totalMoney:0,           //总金额
                materialParams:{
                    number:''        //物料序列号字符串
                },
                dislogSerial:false,  //添加序列号弹出框
                checkCodeList:[],    //查看序列号数组
                codeList:[],         //已扫描序列号数组
                scanTotalList:[],     //超出序列号数组
                dialogTableVisible: false, //弹出框
                pageStatus:'留在当前页面',
                saveStatus:'QR',
                labelPosition:'left',
                returnForm:{
                    operatorName:'废料残值',
                    operatorType:1,   //废料残值
                    scrapValueCount:'',//残值数量
                    createUser:'',
                    scrapValueDetails:[
                        {
                            code:'',
                            materialCode:'',
                            materialName:'',
                            modelId:'',
                            forecastValue:'',
                            memo:''
                        }
                    ],
                    status:'YQR'
                },
                returnData: []
            }
        },
        created(){
            this.returnForm.createUser = JSON.parse(localStorage.getItem('userInfo')).staffName;
        },
        methods: {
            //移除订单
            deleteRow(index, rows) {
                if(rows.length > 0){
                    this.totalCount = this.totalCount - Number(rows[index].count)
                    this.totalMoney = this.totalMoney - Number(rows[index].amount)

                }else{
                    this.totalCount = 0
                    this.totalMoney = 0
                }
                rows.splice(index, 1);
            },
            // 汇总数量和金额
            getAllMoney() {
                this.totalCount = 0
                this.totalMoney = 0
                if (this.returnData) {
                    this.returnData.forEach(element => {
                        this.totalCount += element.count
                        this.totalMoney = this.totalMoney + element.forecastValue * element.count
                    })
                }
            },
            //扫描汇总
            scanCompelte(){
                if(this.codeList.length > 0){
                    this.codeList.forEach((item,index)=>{
                        let arr = [];
                        arr.push(item.code)
                        this.scanTotalList.push({
                            materialCode:item.materialCode,
                            materialName:item.materialName,
                            materialCoding:item.materialCoding,
                            modelId:item.modelId,
                            modelName:item.modelName,
                            state:item.state,
                            forecastValue:item.forecastValue,
                            count:1,
                            codeTotal:arr
                        });
                    })

                }else {
                    this.$message({
                        message: '您还未开始输入或扫描序列号',
                        type: "warning"
                    });
                }
            },
            //查询序列号物料信息
            queryBySerialNumberData(val){
                let isReplace = false
                if(val.length == 8){
                    this.returnData.forEach((item,index)=>{
                        item.codeTotal.forEach((item1,index1)=>{
                            if(item1 == val){
                                this.$message({
                                    message: '当前序列号已添加至列表，请重新输入',
                                    type: "warning"
                                });
                                isReplace = true
                            }
                        })
                    })
                    if(!isReplace){
                        let para = {
                            number:this.materialParams.number,
                            affiliationType:0,
                            status:1
                        }
                        queryBySerialNumber(para).then(res => {
                            if (res.data.status==100) {
                                if(res.data.results.length > 0){
                                    let isHave = false
                                    res.data.results[0].forecastValue = 0;
                                    if(this.codeList.length > 0){
                                        this.codeList.forEach((item,index)=>{
                                            if(item.code == res.data.results[0].code){
                                                isHave = true
                                            }
                                        })
                                        if(!isHave){
                                            this.codeList.push(res.data.results[0])
                                        }
                                    }else{
                                        this.codeList.push(res.data.results[0])
                                    }
                                }else{
                                    this.$message({
                                        message: '您输入的序列号有误，请重新输入',
                                        type: "warning"
                                    });
                                }
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    }
                }
            },
            //提交添加序列号
            addSerialComformBtn(){
                if(this.codeList.length == 0){
                    this.$message({
                        message: '您还未开始输入或扫描序列号',
                        type: "warning"
                    });
                }else if(this.scanTotalList.length == 0){
                    this.$confirm('是否已经完成扫描？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.scanCompelte() //完成扫描
                        this.addEdit()      //添加&修改
                        this.$message({
                            type: 'success',
                            message: '添加成功'
                        });
                    }).catch(() => {

                    });
                }else{
                    this.addEdit() //添加&修改
                }

            },
            //编码相等便修改不相等便添加
            addEdit(){
                if(this.returnData.length > 0){
                    let isAdd = true
                    let obj = {}
                    this.returnData.forEach((item,index)=>{
                        this.scanTotalList.forEach((item1,index1)=>{
                            if(item.materialCode == item1.materialCode){
                                isAdd = false
                                item.codeTotal.forEach((item2,index2) =>{
                                    item1.codeTotal.forEach((item3,index3)=>{
                                        if(item2 == item3){
                                            item2 = item3
                                        }else{
                                            item.codeTotal.push(item3)
                                            item.codeTotal = [...new Set(item.codeTotal)]
                                        }
                                    })
                                })
                            }else{
                                isAdd = true
                            }
                            obj = item1
                        })
                    })
                    if(isAdd){
                        this.returnData.push(obj)
                    }
                    this.returnData.forEach((item,index)=>{
                        this.returnData.forEach((item1,index1)=>{
                            if(item.materialCode == item1.materialCode){
                                if(item.codeTotal.length > item1.codeTotal.length){
                                    this.returnData.splice(index1,1)
                                }
                            }
                        })
                    })
                }else{
                    this.returnData = this.returnData.concat(this.scanTotalList)
                }
                this.returnData.forEach((item,index)=>{
                    item.count = item.codeTotal.length
                })
                this.getAllMoney()
                this.cancelSerial()
            },
            //移除序列号
            deleteCode(index,rows){
                rows.splice(index, 1);
                this.scanCompelte();
            },
            //取消/关闭添加序列号弹出框
            cancelSerial(){
                this.dislogSerial = false
                this.codeList = []
                this.scanTotalList = []
                this.materialParams.number = ""
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/residualManage'
                })
            },
            refresh() {
                this.returnData = []
            },
            showSerialNumber(index, row) {
                this.dialogTableVisible = true;
                this.checkCodeList = Object.assign({}, row).codeTotal;
            },
            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
                ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            },
            //已提交
            DetermineSave(){
                if(this.returnData.length == 0){
                    this.$message({
                        message: '请扫码输入序列号添加物料',
                        type: "warning"
                    });
                }else{
                    let returnMaterialDetails = []
                    let codeSum = 0
                    this.returnData.forEach((item,index)=>{
                        returnMaterialDetails.push({
                            code:item.codeTotal[0],
                            materialCode:item.materialCode,
                            materialName:item.materialName,
                            modelId:item.modelId,
                            forecastValue:item.forecastValue
                        })
                    })
                    let para = {
                        operatorType:1,
                        scrapValueCount:this.returnData.length,
                        scrapValueDetails:returnMaterialDetails
                    }
                    wasteAdd(para).then(res => {
                        if (res.data.status==100) {
                            this.$message({
                                message: '提交成功',
                                type: "success"
                            });
                            if (this.pageStatus == '留在当前页面') {
                                this.returnData = [];
                                this.totalCount = 0;
                                this.totalMoney = 0;
                            }else{
                                this.tabRemove(this.$route.path)
                                this.$router.replace({
                                    path:'/residualManage'
                                })
                            }
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            closeSave(){
                this.pageStatus = "离开当前页面"
            },
            goOnSave(){
                this.pageStatus = "留在当前页面"
            },
            //取消新建
            cancelOrder(){
                this.tabRemove(this.$route.path)
                this.$router.replace({
                    path:'/residualManage'
                })
            },
        },
        computed: {
        },
        watch: {

        }
    }
</script>

<style type="text/css" lang="scss" scoped>
    #newResidual{
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .searthPart{.el-input{width: 100%;}}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .activeBtn{background-color: #1abc9c;color:#fff;}
        .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
        .childSpan{padding-left: 20px;margin-bottom: 5px;}
        .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
        .childSpan span.orderId{color: #3399FF;}
        .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
            background-color: #1abc9c;margin: 0px 15px 0px -5px;}
        }
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
        .scanTitle{
            display:block;
            margin:10px
        }
        .priceContent{
            position:relative;
            .el-input__inner{

                padding-left:30px;
                display:block;

            }
            &:before{
                content:"￥";
                display:block;
                width:30px;
                font-size:14px;
                color:#666;
                position:absolute;
                left:0;
                top:0;
                height:32px;
                line-height:32px;
            }
        }
        .dialog-content{
            width:900px;
            margin:0 auto;
            .dialog-code-content{
                text-align: center;
                .el-col{
                    p{
                        border: 1px solid #e3e3e3;
                        line-height: 40px
                    }

                }
            }
        }
        .totalDiv{
            height: auto;
            overflow: hidden;
            text-align: right;
            font-size: 16px;
            background-color: #fff;
            border-bottom: 1px solid #e5e9f2;
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// newResidual.vue?2140cdc6